export enum RecaptchaProvider {
  V3_ENTERPRISE = 'reCaptchaV3Enterprise',
}
